import React from 'react';

/** Keeps the full reply in the layout and accessible while revealing its visual copy. */
const TypewriterText: React.FC<{ text: string; length: number; typing: boolean }> = ({ text, length, typing }) => (
  <span className="typewriter">
    <span className="sr-only">{text}</span>
    <span
      aria-hidden="true"
      className="typewriter-visual"
    >
      <span className="typewriter-measure">{text}</span>
      <span className={`typewriter-text${typing ? ' is-typing' : ''}`}>{text.slice(0, Math.max(0, length))}</span>
    </span>
  </span>
);

export default TypewriterText;
